import { useMantineTheme } from '@mantine/core';
import { filter, find } from 'lodash/fp';
import React, { FC } from 'react';
import { TooltipProps } from 'recharts';

import { formatCurrency } from '@portals/utils';

import { CustomTooltip } from '../common';

export const ChartLabelRenderer = (props) => {
  const theme = useMantineTheme();
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={5} textAnchor="middle" fill={theme.colors.gray[6]}>
        {payload.value}
      </text>
    </g>
  );
};

export const ReferenceLineLabelRenderer = (props) => {
  const theme = useMantineTheme();

  const {
    viewBox: { x, y },
  } = props;

  return (
    <text x={x} y={y - 10} textAnchor="middle" fill={theme.colors.gray[6]}>
      Today
    </text>
  );
};

export const TooltipRenderer: FC<TooltipProps<any, any>> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    const isForecast =
      !!find({ dataKey: 'forecastRevenue' }, payload) ||
      !!find({ dataKey: 'forecastMrr' }, payload);

    const filteredPayload = isForecast
      ? filter(
          ({ dataKey }) => dataKey !== 'revenue' && dataKey !== 'mrr',
          payload
        )
      : payload;

    return (
      <CustomTooltip
        label={label}
        items={filteredPayload.map(({ value, name, color }) => ({
          label: name,
          value: `${formatCurrency(value, 'USD')}`,
          color,
        }))}
      />
    );
  }

  return null;
};
